module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Thunder-move-09078a2b05d7fb1171b9f7c118ce0d31.svg";